import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Paper,
  Divider,
  IconButton,
  TextField,
  List,
  ListItem,
  ListItemIcon,
  Avatar,
  Dialog,
} from "@mui/material";
import {
  Add as AddIcon,
  Remove as RemoveIcon,
  Check as CheckIcon,
  LocalShipping,
  SupportAgent,
  AssignmentReturn,
  VerifiedUser,
} from "@mui/icons-material";
import productImage from "../../../assets/anveshan-girghee-5ltr-dolchi.jpg";
import productImage2 from "../../../assets/img2.jpg";
import productImage3 from "../../../assets/img3.jpg";
import productImage4 from "../../../assets/img4.jpg";
import simplLogo from "../../../assets/brand.png";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import offerBanner from "../../../assets/anveshan-monsoon-discount-banner.jpg";
import supportImage from "../../../assets/support.png";
import video from "../../../assets/video7.mp4";
import { Fullscreen, FullscreenExit } from "@mui/icons-material";

const DetailPageSection = () => {
  const [selectedImage, setSelectedImage] = useState(productImage);
  const [quantity, setQuantity] = useState(1);
  const [selectedVariant, setSelectedVariant] = useState(2);
  const [isZoomed, setIsZoomed] = useState(false);
  const [pincode, setPincode] = useState("122002");
  const [fullscreenOpen, setFullscreenOpen] = useState(false);

  const productImages = [
    { id: 1, src: productImage, alt: "Main product view" },
    { id: 2, src: productImage2, alt: "Product side view" },
    { id: 3, src: productImage3, alt: "Product packaging" },
    { id: 4, src: productImage4, alt: "Product in use" },
  ];

  const variants = [
    { id: 1, size: "500ml Jar", price: 1176, mrp: 1250, discount: "5%" },
    { id: 2, size: "1L Jar", price: 2330, mrp: 2400, discount: "2%" },
    { id: 3, size: "5L Dolchi", price: 1529, mrp: 1999, discount: "3%" },
  ];

  const handleQuantityChange = (value) => {
    const newQuantity = quantity + value;
    if (newQuantity >= 1 && newQuantity <= 10) {
      setQuantity(newQuantity);
    }
  };

  const handleFullscreenOpen = () => {
    setFullscreenOpen(true);
  };

  const handleFullscreenClose = () => {
    setFullscreenOpen(false);
  };
  return (
    <Grid container sx={{ minHeight: "100vh", maxWidth: "1400px", mx: "auto" }}>
      {/* Left: Fixed Section */}
      <Grid item xs={12} md={5}>
        <Box
          sx={{
            position: "sticky",
            top: 0,
            height: "100vh",
            display: "flex",
            width: "100%",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Box
            onClick={handleFullscreenOpen}
            sx={{
              position: "relative",
              overflow: "hidden",
              transform: isZoomed ? "scale(1.5)" : "scale(1)",
              transformOrigin: "center",
              zIndex: isZoomed ? 9999 : "auto",
              transition: "all 0.3s ease",
              cursor: "zoom-in",
            }}
          >
            <Box
              component="img"
              src={selectedImage}
              alt="A2 Gir Cow Ghee"
              sx={{
                width: "100%",
                maxHeight: "70vh",
                objectFit: "contain",
                transition: "transform 0.3s ease",
              }}
            />
          </Box>

          {/* Fullscreen Dialog */}
          <Dialog
            open={fullscreenOpen}
            onClose={handleFullscreenClose}
            fullScreen
            maxWidth="lg"
            sx={{
              "& .MuiDialog-paper": {
                backgroundColor: "rgba(0,0,0,0.9)",
                overflow: "hidden",
              },
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 4,
              }}
            >
              <IconButton
                onClick={handleFullscreenClose}
                sx={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  color: "common.white",
                  backgroundColor: "rgba(0,0,0,0.5)",
                  "&:hover": {
                    backgroundColor: "rgba(0,0,0,0.8)",
                  },
                }}
              >
                <FullscreenExit />
              </IconButton>

              <Box
                component="img"
                src={selectedImage}
                alt="Product Image - Fullscreen"
                sx={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                  cursor: "zoom-out",
                }}
                onClick={handleFullscreenClose}
              />
            </Box>
          </Dialog>

          {/* Thumbnail Gallery */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              mt: 3,
              justifyContent: "center",
            }}
          >
            {productImages.map((image) => (
              <Box
                key={image.id}
                sx={{
                  transition: "all 0.3s ease",
                  transform: "scale(1)",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={image.src}
                  alt={image.alt}
                  sx={{
                    width: 60,
                    height: 60,
                    objectFit: "cover",
                    borderRadius: 1,
                    cursor: "pointer",
                    border: selectedImage === image.src ? 2 : 0,
                    borderColor: "primary.main",
                    opacity: selectedImage === image.src ? 1 : 0.7,
                    transition: "all 0.3s ease",
                  }}
                  onClick={() => setSelectedImage(image.src)}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Grid>

      {/* Right: Scrollable Section */}
      <Grid item xs={12} md={7}>
        <Box
          sx={{
            maxHeight: "100vh",
            overflowY: "auto",
            maxWidth: "650px",
            mt: 2,
            p: 3,
            bgcolor: "#fff",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "26px",
            }}
          >
            A2 Gir Cow Ghee
          </Typography>

          <Typography color="grey" sx={{ fontSize: "16px" }}>
            Milk from Gir Cows of Gujarat | Nutrient Dense & Heart-Healthy |
            Bilona-Churned | 70+ Quality Checks
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 2,
              mb: 1,
            }}
          >
            <Box>
              {/* Dummy star icons - replace with <Rating /> from MUI if needed */}
              <Typography
                variant="body2"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "1.5rem",
                  color: "#f5a623",
                }}
              >
                {"★".repeat(5)}
                <span
                  style={{
                    marginLeft: 8,
                    fontWeight: 500,
                    color: "grey",
                    fontSize: "0.95rem",
                  }}
                >
                  241 reviews
                </span>
              </Typography>

              {/* View all reviews link */}
              <Typography
                variant="body2"
                color="primary"
                sx={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  color: "black",
                }}
              >
                View all reviews
              </Typography>
            </Box>
            <Box>
              {/* Price */}
              <Typography variant="h4" sx={{ fontWeight: 700 }}>
                ₹{variants[selectedVariant].price.toLocaleString()}
              </Typography>
              <Typography
                component="span"
                variant="body1"
                color="grey"
                sx={{ textDecoration: "line-through", mr: 1 }}
              >
                ₹{variants[selectedVariant].mrp.toLocaleString()}
              </Typography>
              <Typography
                component="span"
                variant="body1"
                color="success.main"
                sx={{ fontWeight: 600 }}
              >
                {variants[selectedVariant].discount} OFF
              </Typography>
            </Box>
          </Box>

          <Typography
            sx={{ fontSize: "12px", textAlign: "right", color: "grey", mt: -1 }}
          >
            MRP (Incl. of all taxes)
          </Typography>

          <Paper
            elevation={1}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 2,
              py: 1.5,
              borderRadius: 3,
              border: "1px solid #f0e8e8ff",
              width: "fit-content",
              maxWidth: "100%",
              boxShadow: "0px 1px 5px rgba(0,0,0,0.1)",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <AccountBalanceWalletIcon fontSize="small" />
              <Typography variant="body2">
                Pay{" "}
                <Typography
                  component="span"
                  variant="body2"
                  sx={{ fontWeight: 600, color: "success.main" }}
                >
                  ₹776.68
                </Typography>
                /month in Easy, Interest-Free Installments.
              </Typography>
            </Box>

            <Box
              component="img"
              src={simplLogo}
              alt="Simpl"
              sx={{ height: 20, ml: 2 }}
            />
          </Paper>
          <Typography
            variant="body2"
            sx={{
              my: 3,
              color: "success.main",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Box
              component="span"
              sx={{
                bgcolor: "success.light",
                color: "success.dark",
                px: 1,
                borderRadius: 1,
              }}
            >
              ★
            </Box>
            Earn {Math.floor(variants[selectedVariant].price * 0.05)} points on
            this product
          </Typography>

          <Typography
            fontWeight={600}
            sx={{ mb: 1, color: "grey", fontSize: "1rem" }}
          >
            Select Variant
          </Typography>

          <Grid
            container
            spacing={1}
            sx={{ mb: 3, flexWrap: "nowrap", overflowX: "auto", pb: 1 }}
          >
            {variants.map((variant, index) => {
              const sizeInLiters = variant.size.includes("500ml")
                ? 0.5
                : variant.size.includes("1L")
                ? 1
                : 5;
              const pricePerLiter =
                Math.round((variant.price / sizeInLiters) * 1000) / 1000;

              return (
                <Grid item xs="auto" key={variant.id}>
                  <Paper
                    variant="outlined"
                    sx={{
                      width: 200,
                      p: 0,
                      cursor: "pointer",
                      borderColor:
                        selectedVariant === index ? "#00584b" : "divider",
                      borderWidth: selectedVariant === index ? 1.5 : 1,
                      position: "relative",
                      overflow: "hidden",
                      transition: "all 0.3s ease",
                    }}
                    onClick={() => setSelectedVariant(index)}
                  >
                    <Box
                      sx={{
                        px: 1.5,
                        py: 0.5,
                        borderBottom: 0.5,
                        color: selectedVariant === index ? "white" : "black",
                        bgcolor:
                          selectedVariant === index ? "#00584b" : "#f1f4fb",
                        borderColor: "divider",
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        className="variant-title"
                        sx={{}}
                      >
                        {variant.size}
                      </Typography>
                    </Box>

                    <Box sx={{ px: 1.5 }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        <Typography
                          variant="h6"
                          fontWeight={700}
                          className="price-text"
                        >
                          ₹{variant.price.toLocaleString()}
                        </Typography>
                        <Typography
                          variant="body2"
                          className="price-text"
                          sx={{
                            textDecoration: "line-through",
                            color: "text.secondary",
                          }}
                        >
                          ₹{variant.mrp.toLocaleString()}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "success.main",
                            fontWeight: 600,
                            bgcolor: "success.light",
                            px: 0.5,
                            borderRadius: 0.5,
                          }}
                        >
                          {variant.discount} off
                        </Typography>
                      </Box>

                      <Typography
                        variant="caption"
                        className="price-text"
                        color="text.secondary"
                      >
                        ₹{pricePerLiter}/L
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>
              );
            })}
          </Grid>

          <Box sx={{ mt: 2 }}>
            <Box
              component="img"
              src={offerBanner}
              alt="Offer"
              sx={{ width: "100%", borderRadius: 2 }}
            />
          </Box>

          <Paper
            sx={{
              p: 2,
              my: 2,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              color="success.dark"
              fontWeight="bold"
            >
              Delivery Date
            </Typography>
            <Typography variant="body2">
              Enter Pin code to check <b>delivery date</b>
            </Typography>

            <Box display="flex" alignItems="center">
              <TextField
                placeholder="Enter Pincode"
                value={pincode}
                size="small"
                onChange={(e) => setPincode(e.target.value)}
                sx={{ flex: 1 }}
              />
              <Button
                variant="contained"
                color="success"
                sx={{ px: 3, py: 1, backgroundColor: "#00584b" }}
              >
                Check
              </Button>
            </Box>
          </Paper>

          {/* Quantity and Cart Buttons */}
          <Box sx={{ mb: 2 }}>
            <Box display="flex" alignItems="center" gap={2}>
              <Paper
                variant="outlined"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: 2,
                  overflow: "hidden",
                }}
              >
                <IconButton
                  onClick={() => handleQuantityChange(-1)}
                  disabled={quantity === 1}
                  color="grey"
                >
                  <RemoveIcon sx={{ backgroundColor: "#f1f2f1" }} />
                </IconButton>
                <Box sx={{ px: 2, minWidth: 40, textAlign: "center" }}>
                  {quantity}
                </Box>
                <IconButton
                  onClick={() => handleQuantityChange(1)}
                  disabled={quantity === 10}
                  color="grey"
                >
                  <AddIcon sx={{ backgroundColor: "#f1f2f1" }} />
                </IconButton>
              </Paper>

              <Button
                variant="contained"
                color="success"
                sx={{
                  borderRadius: 6,
                  backgroundColor: "#00584b",
                  px: 3.5,
                  py: 1,
                  flex: 1,
                  boxShadow: "none",
                  "&:hover": {
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    transform: "translateY(-2px)",
                  },
                  transition: "all 0.3s ease",
                }}
                size="large"
              >
                Add to cart
              </Button>

              <Button
                variant="contained"
                sx={{
                  bgcolor: "warning.main",
                  color: "#00584b",
                  backgroundColor: "#efc905",
                  borderRadius: 6,
                  px: 3.5,
                  py: 1,
                  mb: 1,
                  flex: 1,
                  fontWeight: 600,
                  boxShadow: "none",
                  "&:hover": {
                    bgcolor: "warning.dark",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    transform: "translateY(-2px)",
                  },
                  transition: "all 0.3s ease",
                }}
                size="large"
              >
                Buy Now
              </Button>
            </Box>
          </Box>

          {/* Product Description */}
          <Box sx={{ mb: 3.5 }}>
            <Typography variant="body1" fontWeight={700} sx={{ mb: 2 }}>
              PRODUCT DESCRIPTION
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              Made in the farms of Gujarat, our A2 Gir Cow Ghee is the epitome
              of purity. Made using verified A2 milk of Gir Cows, this
              single-source ghee will change the way you think about ghee.
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              Traditionally churned from curd, not cream, this ghee is light on
              your gut and full of nutrients and heart-healthy fats. No hidden
              ingredients, no shortcuts. Only 100% A2 ghee.
            </Typography>
          </Box>

          <Box sx={{ mt: 2 }}>
            <Box
              component="img"
              src={supportImage}
              alt="Offer"
              sx={{ width: "100%", borderRadius: 2 }}
            />
          </Box>
        </Box>
      </Grid>
      <Grid
        container
        direction="column"
        alignItems="center"
        sx={{ my: 3, width: "100%" }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "32px",
            color: "#00584b",
            textAlign: "center", // Optional: for better visual on large screens
          }}
        >
          Where Happy Cows Roam
        </Typography>

        <Box
          sx={{
            mt: 2,
            width: "100%",
            maxWidth: "1200px",
          }}
        >
          <Box
            component="iframe"
            src={video}
            title="Product Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            sx={{
              width: "100%",
              height: "60vh",
              borderRadius: 2,
              border: 0,
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default DetailPageSection;
